import { headerBgHeight } from './HeaderBgStore.js';

export const updateHeaderBgHeight = (value) => headerBgHeight.update(oldValue => value);
